export const blockIconsSearchTableBar = (
	<span className='material-symbols-outlined'>table_bar</span>
);
